import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import {
	Avatar,
	Heading3,
	Paragraph,
	PlainCard,
	QuillText,
	Skeleton,
	tokens,
} from '@treams/treams-ui';

export default Skeleton(
	function OutgoingComplimentCard(props: { compliment: graphql.Compliment }) {
		const { t } = useTranslation();
		const preview = QuillText.toPlainText(props.compliment.text);

		return (
			<PlainCard
				to={`/users/${props.compliment.recipient.id}/feedback/compliments/${props.compliment.id}`}
			>
				<Flex alignItems="center" minWidth={0} style={{ gap: tokens.gap.group }}>
					<Avatar size={48} user={props.compliment.recipient} flexGrow={0} flexShrink={0} />
					<Box flexGrow={1} flexShrink={1} minWidth={0} overflow="hidden">
						<Heading3>
							{t('feedback.compliments.outgoing.card.title', {
								sender: [
									props.compliment.recipient.firstName,
									props.compliment.recipient.lastName,
								].join(' '),
							})}
						</Heading3>
						<Paragraph mt={`${tokens.gap.inline}px`}>
							{t('feedback.compliments.outgoing.card.sentAt', {
								date: moment(props.compliment.createdAt).format('LL'),
							})}
						</Paragraph>
						{preview && (
							<Paragraph
								mt={`${tokens.gap.inline}px`}
								lineClamp={1}
								fontStyle="italic"
								style={{ color: tokens.text.primary }}
							>
								{preview}
							</Paragraph>
						)}
					</Box>
				</Flex>
			</PlainCard>
		);
	},
	function OutgoingComplimentCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center" minWidth={0} style={{ gap: tokens.gap.group }}>
					<Avatar.Skeleton size={48} flexGrow={0} flexShrink={0} />
					<Box flexGrow={1} flexShrink={1} minWidth={0}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton mt={`${tokens.gap.inline}px`} lines={1} />
						<Paragraph.Skeleton mt={`${tokens.gap.inline}px`} lines={1} />
					</Box>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
